import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2, ShieldCheck, Zap, FileText } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 px-4 bg-slate-950 relative" data-id="element-205">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 blur-[150px] rounded-full pointer-events-none" data-id="element-206" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-207">
        {/* Value Stack */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-slate-900 border border-slate-800 rounded-3xl p-8 mb-16 shadow-2xl" data-id="element-208">
          <h3 className="text-2xl font-black text-white mb-6 text-center" data-id="element-209">
            💰 RESUMEN DE VALOR TOTAL
          </h3>
          <div className="space-y-3 mb-6" data-id="element-210">
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-211">
              <span className="text-slate-300 font-medium" data-id="element-212">
                6 Tomos Completos
              </span>
              <span className="text-slate-500 line-through" data-id="element-213">$18.000</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-214">
              <span className="text-slate-300 font-medium" data-id="element-215">
                Bono 1 — Guía de Emergencia
              </span>
              <span className="text-slate-500 line-through" data-id="element-216">$5.000</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-217">
              <span className="text-slate-300 font-medium" data-id="element-218">
                Bono 2 — Calendario de Rutinas
              </span>
              <span className="text-slate-500 line-through" data-id="element-219">$4.500</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-220">
              <span className="text-slate-300 font-medium" data-id="element-221">
                Bono 3 — Kit Escuela-Hogar
              </span>
              <span className="text-slate-500 line-through" data-id="element-222">$4.000</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-223">
              <span className="text-slate-300 font-medium" data-id="element-224">
                Bono 4 — Diario Emocional
              </span>
              <span className="text-slate-500 line-through" data-id="element-225">$5.500</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-226">
              <span className="text-slate-300 font-medium" data-id="element-227">
                Bono 5 — Guía de Alimentación
              </span>
              <span className="text-slate-500 line-through" data-id="element-228">$4.500</span>
            </div>
            <div className="flex justify-between items-center pb-3 border-b border-slate-800" data-id="element-229">
              <span className="text-slate-300 font-medium" data-id="element-230">
                Bono 6 — Mapa de Fortalezas
              </span>
              <span className="text-slate-500 line-through" data-id="element-231">$4.500</span>
            </div>
          </div>
          <div className="flex justify-between items-center mb-2" data-id="element-232">
            <span className="text-xl font-bold text-slate-400" data-id="element-233">
              VALOR TOTAL
            </span>
            <span className="text-2xl font-bold text-red-500 line-through" data-id="element-234">
              $46.000
            </span>
          </div>
          <div className="flex justify-between items-center bg-amber-500/10 p-4 rounded-xl border border-amber-500/20" data-id="element-235">
            <span className="text-xl font-black text-amber-400" data-id="element-236">
              → Tu precio hoy
            </span>
            <span className="text-3xl font-black text-amber-400" data-id="element-237">$19.990</span>
          </div>
        </motion.div>

        {/* Urgency Section */}
        <div className="text-center mb-12" data-id="element-238">
          <h3 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-239">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
          <CountdownTimer data-id="element-240" />
          <p className="text-red-400 font-bold mt-4 flex items-center justify-center gap-2" data-id="element-241">
            ⚠️ Después sube. No vuelve.
          </p>

          <div className="max-w-md mx-auto mt-8 bg-slate-900 p-4 rounded-xl border border-red-500/20" data-id="element-242">
            <div className="flex justify-between text-sm font-bold mb-2" data-id="element-243">
              <span className="text-red-400" data-id="element-244">
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-slate-400" data-id="element-245">Quedan pocos</span>
            </div>
            <div className="w-full bg-slate-800 rounded-full h-4 overflow-hidden" data-id="element-246">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-gradient-to-r from-red-600 to-red-400 h-full rounded-full relative" data-id="element-247">
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMSI+PC9yZWN0Pgo8cGF0aCBkPSJNMCAwTDggOFpNOCAwTDAgOFoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9IjAuMiIgc3Ryb2tlLXdpZHRoPSIxIj48L3BhdGg+Cjwvc3ZnPg==')] opacity-30" data-id="element-248"></div>
              </motion.div>
            </div>
            <p className="text-xs text-slate-400 mt-2 text-right" data-id="element-249">
              68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="text-center mb-10" data-id="element-250">
          <h2 className="text-4xl font-black text-white" data-id="element-251">🛒 ELEGÍ TU COMBO</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-252">
          {/* Standard Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-900 border border-slate-700 rounded-3xl p-8 flex flex-col relative" data-id="element-253">
            <div className="mb-6" data-id="element-254">
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-255">
                📘 NUEVO NIVEL
                <br data-id="element-256" />
                <span className="text-amber-400" data-id="element-257">COMBO TDAH COMPLETO</span>
              </h3>
              <p className="text-slate-300 font-bold mb-4" data-id="element-258">6 Tomos + 6 Bonos</p>
              <p className="text-sm text-slate-400 bg-slate-800 p-3 rounded-lg" data-id="element-259">
                <span className="font-bold text-white" data-id="element-260">Ideal para:</span> Padres
                que quieren un sistema completo desde el diagnóstico hasta el
                futuro
              </p>
            </div>

            <div className="mb-8" data-id="element-261">
              <div className="text-slate-500 line-through text-lg font-bold mb-1" data-id="element-262">
                Valor real: $46.000
              </div>
              <div className="text-5xl font-black text-white mb-2" data-id="element-263">
                $19.990{' '}
                <span className="text-xl text-slate-500 font-bold" data-id="element-264">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-265">
              <a href="https://www.nuevonivel.shop/cart/49840985538800:1" className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 text-xl font-black py-4 px-6 rounded-xl transition-all hover:scale-[1.02] active:scale-95 shadow-[0_0_20px_rgba(245,158,11,0.3)] flex justify-center items-center gap-2" data-id="element-266">
                → QUIERO MI COMBO AHORA
              </a>
              <p className="text-center text-slate-500 text-xs mt-4 flex items-center justify-center gap-1" data-id="element-267">
                <ShieldCheck className="w-3 h-3" data-id="element-268" /> Garantía 7 días · 🌐
                www.nuevonivel.shop
              </p>
            </div>
          </motion.div>

          {/* Premium Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-slate-800 to-slate-900 border-2 border-amber-400 rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(245,158,11,0.15)]" data-id="element-269">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-400 text-slate-950 font-black px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-270">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-6" data-id="element-271">
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-272">
                🏆 NUEVO NIVEL
                <br data-id="element-273" />
                <span className="text-amber-400" data-id="element-274">+ PROTOCOLO 30 DÍAS</span>
              </h3>
              <p className="text-slate-300 font-bold mb-4" data-id="element-275">
                6 Tomos + 6 Bonos + Plan de Implementación Diaria
              </p>
              <p className="text-sm text-amber-100 bg-amber-500/20 p-3 rounded-lg border border-amber-500/30" data-id="element-276">
                <span className="font-bold text-amber-400" data-id="element-277">Ideal para:</span>{' '}
                Padres que quieren resultados desde el primer día con un plan de
                acción concreto día por día
              </p>
            </div>

            <div className="mb-8" data-id="element-278">
              <div className="text-slate-500 line-through text-lg font-bold mb-1" data-id="element-279">
                Valor real: $58.000
              </div>
              <div className="text-5xl font-black text-white mb-2" data-id="element-280">
                $27.990{' '}
                <span className="text-xl text-slate-500 font-bold" data-id="element-281">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-282">
              <a href="https://www.nuevonivel.shop/cart/49840986226928:1" className="w-full bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 text-white text-xl font-black py-4 px-6 rounded-xl transition-all hover:scale-[1.02] active:scale-95 shadow-[0_0_30px_rgba(239,68,68,0.4)] flex justify-center items-center gap-2" data-id="element-283">
                → QUIERO EL COMBO + PROTOCOLO
              </a>
              <p className="text-center text-slate-400 text-xs mt-4 flex items-center justify-center gap-1" data-id="element-284">
                <Zap className="w-3 h-3 text-amber-400" data-id="element-285" /> Acceso inmediato · 🌐
                www.nuevonivel.shop
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}